import { isValid, parseISO } from 'date-fns'

export const isValidISOString = (value: unknown): value is string =>
  typeof value === 'string' && isValid(parseISO(value))

export const toEpochMilli = (value?: string | number | Date) => {
  if (!value) {
    return 0
  }
  const dateObj = new Date(value)
  return dateObj.getTime() - dateObj.getTimezoneOffset() * 60 * 1000
}
